/* unplugin-vue-components disabled */import { render } from "./403.vue?vue&type=template&id=584ba432&scoped=true"
const script = {}

import "./403.vue?vue&type=style&index=0&id=584ba432&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584ba432"]])

export default __exports__